export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The hormonal transition looks overwhelming and you feel buried in confusion. This method organizes everything: first the hormone blueprint, then metabolic cooling, circadian repair, cognitive shield, vital motion, and finally the daily map.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with sudden hot flashes (and they ruin your day)',
    desc: 'You learn here the natural cooling way, so you recognize nutrient patterns and adjust your habits with real intention. No more hiding from social events or sweating through meetings.',
  },
  {
    emoji: '🧩',
    title: "You try to eat healthy but can't get rid of the 'Meno-Belly'",
    desc: 'You learn the complete lifestyle phase structure to build habits that actually make sense for your changing metabolism, putting your body on a real path to active fat-burning.',
  },
  {
    emoji: '💭',
    title: 'You take supplements but forget the safety criteria',
    desc: 'You get concrete, science-backed supplement checkpoints and natural apothecary guidelines so what you take actually works instead of throwing money away.',
  },
  {
    emoji: '🎯',
    title: 'You manage your daily symptoms but fear long-term health risks',
    desc: 'Guessing with your health is dangerous. A clear natural framework is what keeps your bones safe, your heart protected, and your energy high.',
  },
  {
    emoji: '🔁',
    title: 'You started a health protocol and quit after two weeks',
    desc: 'One-off restrictions are not progress. A complete 6-volume system with visible daily milestones is what keeps you going until you achieve true hormone harmony.',
  },
];
